/* Visivio — depth layer: CSS-3D tilt, scroll parallax, and a hand-written
   WebGL point field in the hero. No library.
   Colour and blend mode come from the CSS palette, so the same geometry
   reads as glow on a dark ground or as printed ink on a light one.
   On cursorless devices vv-mobile.js drives the field through vvField. */
(function () {
  'use strict';
  if (window.__vv3d) return;
  window.__vv3d = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- A. POINTER TILT (cursor only) ---------- */
  function tilt() {
    if (reduce || !fine) return;
    var MAX = 5.5;
    Array.prototype.forEach.call(document.querySelectorAll('.vv-card, .vv-step, .vv-pc'), function (el) {
      if (el.getAttribute('data-vv-tilt')) return;
      el.setAttribute('data-vv-tilt', '1');
      el.classList.add('vv-tilt');
      if (getComputedStyle(el).position === 'static') el.style.position = 'relative';

      var sheen = document.createElement('span');
      sheen.className = 'vv-sheen';
      el.appendChild(sheen);

      var frame = null, rect = null;
      function apply(e) {
        if (!rect) rect = el.getBoundingClientRect();
        var px = (e.clientX - rect.left) / rect.width;
        var py = (e.clientY - rect.top) / rect.height;
        if (frame) return;
        frame = requestAnimationFrame(function () {
          frame = null;
          el.style.transform = 'perspective(1100px) rotateX(' + ((0.5 - py) * MAX * 2).toFixed(2) +
            'deg) rotateY(' + ((px - 0.5) * MAX * 2).toFixed(2) + 'deg) translateY(-3px)';
          el.style.setProperty('--vv-mx', (px * 100).toFixed(1) + '%');
          el.style.setProperty('--vv-my', (py * 100).toFixed(1) + '%');
        });
      }
      el.addEventListener('pointerenter', function (e) { rect = el.getBoundingClientRect(); el.classList.add('is-tilting'); apply(e); });
      el.addEventListener('pointermove', apply);
      el.addEventListener('pointerleave', function () {
        if (frame) { cancelAnimationFrame(frame); frame = null; }
        rect = null;
        el.classList.remove('is-tilting');
        el.style.transform = '';
      });
    });
  }

  /* ---------- B. SCROLL PARALLAX ---------- */
  function parallax() {
    if (reduce) return;
    var layers = document.querySelectorAll('.vv-hero__grid');
    if (!layers.length) return;
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        var y = window.pageYOffset;
        Array.prototype.forEach.call(layers, function (l) {
          l.style.transform = 'translate3d(0,' + (y * 0.10).toFixed(1) + 'px,0)';
        });
      });
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* ---------- C. WEBGL DEPTH FIELD ---------- */
  var VS = [
    'attribute vec2 aGrid;',
    'uniform float uTime;',
    'uniform vec2 uPointer;',
    'uniform float uAspect;',
    'uniform float uSize;',
    'varying float vFade;',
    'void main(){',
    '  float x = aGrid.x;',
    '  float z = aGrid.y;',
    '  float y = sin(x*1.7 + uTime*0.42)*0.45 + cos(z*1.35 - uTime*0.31)*0.45;',
    '  y += sin((x+z)*0.9 + uTime*0.21)*0.18;',
    '  vec3 p = vec3(x + uPointer.x*0.12, y + uPointer.y*0.06 - 1.9, z + 2.55);',
    '  float persp = 1.0 / max(p.z, 0.12);',
    '  gl_Position = vec4(vec2(p.x * persp / uAspect, p.y * persp), 0.0, 1.0);',
    '  float depth = clamp(1.0 - (p.z - 2.4) / 4.2, 0.0, 1.0);',
    '  vFade = depth * depth * (0.5 + 0.5 * smoothstep(-0.35, 0.45, y));',
    '  gl_PointSize = max(uSize * persp * 1.5, 1.0);',
    '}'
  ].join('\n');

  var FS = [
    'precision mediump float;',
    'varying float vFade;',
    'uniform vec3 uCol;',
    'uniform float uDim;',
    'void main(){',
    '  vec2 c = gl_PointCoord - vec2(0.5);',
    '  float d = dot(c, c);',
    '  if (d > 0.25) discard;',
    '  float soft = smoothstep(0.25, 0.02, d);',
    '  vec3 col = mix(mix(uCol, vec3(uDim), 0.72), uCol, vFade);',
    '  gl_FragColor = vec4(col, soft * vFade * 0.9);',
    '}'
  ].join('\n');

  function compile(gl, type, src) {
    var s = gl.createShader(type);
    gl.shaderSource(s, src);
    gl.compileShader(s);
    if (!gl.getShaderParameter(s, gl.COMPILE_STATUS)) { gl.deleteShader(s); return null; }
    return s;
  }

  function field() {
    if (reduce) return;
    var hero = document.querySelector('.vv-hero[data-vv3d="true"]');
    if (!hero || hero.getAttribute('data-gl')) return;

    var canvas = document.createElement('canvas');
    canvas.className = 'vv-hero__gl';
    canvas.setAttribute('aria-hidden', 'true');

    var gl = null;
    try {
      gl = canvas.getContext('webgl', { alpha: true, antialias: true, depth: false, premultipliedAlpha: false })
        || canvas.getContext('experimental-webgl', { alpha: true, antialias: true, depth: false });
    } catch (e) { gl = null; }
    if (!gl) return;

    var vs = compile(gl, gl.VERTEX_SHADER, VS);
    var fs = compile(gl, gl.FRAGMENT_SHADER, FS);
    if (!vs || !fs) return;
    var prog = gl.createProgram();
    gl.attachShader(prog, vs); gl.attachShader(prog, fs); gl.linkProgram(prog);
    if (!gl.getProgramParameter(prog, gl.LINK_STATUS)) return;

    hero.setAttribute('data-gl', '1');
    hero.insertBefore(canvas, hero.firstChild);
    document.documentElement.classList.add('vv-gl-on');

    var small = window.innerWidth < 900;
    var COLS = small ? 46 : 78;
    var ROWS = small ? 26 : 38;
    var COUNT = COLS * ROWS;
    var data = new Float32Array(COUNT * 2);
    var k = 0;
    for (var r = 0; r < ROWS; r++) {
      for (var c = 0; c < COLS; c++) {
        data[k++] = (c / (COLS - 1) - 0.5) * 7.4;
        data[k++] = (r / (ROWS - 1)) * 4.3;
      }
    }

    var buf = gl.createBuffer();
    gl.bindBuffer(gl.ARRAY_BUFFER, buf);
    gl.bufferData(gl.ARRAY_BUFFER, data, gl.STATIC_DRAW);

    gl.useProgram(prog);
    var aGrid = gl.getAttribLocation(prog, 'aGrid');
    gl.enableVertexAttribArray(aGrid);
    gl.vertexAttribPointer(aGrid, 2, gl.FLOAT, false, 0, 0);

    var uTime = gl.getUniformLocation(prog, 'uTime');
    var uPointer = gl.getUniformLocation(prog, 'uPointer');
    var uAspect = gl.getUniformLocation(prog, 'uAspect');
    var uSize = gl.getUniformLocation(prog, 'uSize');

    var additive = window.vvGLAdditive ? window.vvGLAdditive() : true;
    var col = window.vvAccentRGB ? window.vvAccentRGB([0.38, 0.65, 0.98]) : [0.38, 0.65, 0.98];
    gl.uniform3f(gl.getUniformLocation(prog, 'uCol'), col[0], col[1], col[2]);
    gl.uniform1f(gl.getUniformLocation(prog, 'uDim'), additive ? 0.0 : 1.0);

    gl.disable(gl.DEPTH_TEST);
    gl.enable(gl.BLEND);
    if (additive) gl.blendFunc(gl.SRC_ALPHA, gl.ONE);
    else gl.blendFunc(gl.SRC_ALPHA, gl.ONE_MINUS_SRC_ALPHA);

    var dpr = 1;
    function resize() {
      dpr = Math.min(window.devicePixelRatio || 1, 2);
      var W = hero.clientWidth, H = hero.clientHeight;
      canvas.width = Math.floor(W * dpr);
      canvas.height = Math.floor(H * dpr);
      gl.viewport(0, 0, canvas.width, canvas.height);
      gl.uniform1f(uAspect, Math.max(W / Math.max(H, 1), 0.3));
      gl.uniform1f(uSize, (small ? 11 : 14) * dpr);
    }
    resize();

    var px = 0, py = 0, tx = 0, ty = 0;
    if (fine) {
      window.addEventListener('pointermove', function (e) {
        tx = (e.clientX / window.innerWidth - 0.5) * 2;
        ty = (e.clientY / window.innerHeight - 0.5) * 2;
      }, { passive: true });
    }

    /* cursorless devices steer the same field from scroll / device tilt */
    window.vvField = {
      setPointer: function (x, y) {
        if (typeof x === 'number') tx = Math.max(-1.5, Math.min(x, 1.5));
        if (typeof y === 'number') ty = Math.max(-1.5, Math.min(y, 1.5));
      }
    };

    var visible = true, running = true, raf = null, t0 = null;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(hero);
    }
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running && !raf) raf = requestAnimationFrame(draw);
    });

    var ro = null;
    if ('ResizeObserver' in window) { ro = new ResizeObserver(resize); ro.observe(hero); }
    else { window.addEventListener('resize', resize); }

    function draw(ts) {
      raf = null;
      if (!running) return;
      if (!t0) t0 = ts;
      if (visible) {
        px += (tx - px) * 0.045;
        py += (ty - py) * 0.045;
        gl.uniform1f(uTime, (ts - t0) / 1000);
        gl.uniform2f(uPointer, px, py);
        gl.clearColor(0, 0, 0, 0);
        gl.clear(gl.COLOR_BUFFER_BIT);
        gl.drawArrays(gl.POINTS, 0, COUNT);
      }
      raf = requestAnimationFrame(draw);
    }
    raf = requestAnimationFrame(draw);
    requestAnimationFrame(function () { canvas.classList.add('is-live'); });

    window.addEventListener('pagehide', function () {
      if (raf) cancelAnimationFrame(raf);
      running = false;
      if (ro) ro.disconnect();
      try {
        gl.deleteBuffer(buf); gl.deleteProgram(prog);
        gl.deleteShader(vs); gl.deleteShader(fs);
        var lose = gl.getExtension('WEBGL_lose_context');
        if (lose) lose.loseContext();
      } catch (e) {}
    });
  }

  function init() {
    try { tilt(); } catch (e) {}
    try { parallax(); } catch (e) {}
    try { field(); } catch (e) {}
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); }
  else { init(); }
  document.addEventListener('shopify:section:load', function () { try { tilt(); } catch (e) {} });
})();
